var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"text-center",attrs:{"size":Math.max(5, (_vm.text || '').length + 1),"readonly":_vm.readonly},domProps:{"value":_vm.text},on:{"input":function($event){return _vm.input($event.target.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }